import React from 'react';
import { Section } from './Section';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <Section className="bg-cream" data-id="element-245">
      <div className="max-w-3xl mx-auto" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gradient-to-br from-forest to-forest-light text-cream rounded-3xl p-8 md:p-12 shadow-2xl border-[6px] border-gold ring-4 ring-gold/20 ring-offset-4 ring-offset-cream relative overflow-hidden" data-id="element-247">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-gold/10 rounded-full blur-2xl" data-id="element-248"></div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-gold/10 rounded-full blur-2xl" data-id="element-249"></div>

          <div className="flex flex-col md:flex-row items-center gap-8 relative z-10" data-id="element-250">
            <div className="flex-shrink-0" data-id="element-251">
              <div className="bg-gold rounded-full w-32 h-32 md:w-40 md:h-40 flex items-center justify-center shadow-xl border-4 border-cream" data-id="element-252">
                <div className="text-center text-forest" data-id="element-253">
                  <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-1" strokeWidth={2.5} data-id="element-254" />
                  <p className="font-serif font-bold text-xl md:text-2xl leading-none" data-id="element-255">
                    7
                  </p>
                  <p className="font-bold text-xs uppercase tracking-wider" data-id="element-256">
                    Días
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center md:text-left flex-1" data-id="element-257">
              <p className="text-gold font-bold text-lg md:text-xl uppercase tracking-widest mb-3" data-id="element-258">
                Garantía Total
              </p>
              <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-cream" data-id="element-259">
                Pruébalo con tranquilidad
              </h2>
              <p className="text-cream-dark text-lg leading-relaxed" data-id="element-260">
                Tu compra incluye garantía de 7 días, para que revises el
                contenido y decidas si este reset es para ti.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}